import { stringConstraints } from '@utils';
import { z } from 'zod';

export const vehicleDetailsSchema = z.object({
  registrationNumber: stringConstraints('Enter a registration number'),
  make: z.string(),
  model: z.string(),
  colour: z.string(),
});
